import {
	convertChartData,
	IAppBuilderWidgetPropsAreaChart,
} from "@AppBuilderLib/features/appbuilder/config/appbuildercharts";
import type {MantineAreaChartProps} from "@AppBuilderLib/shared/mantine-props/areaChart";
import type {MantinePaperProps} from "@AppBuilderLib/shared/mantine-props/paper";
import type {MantineTitleProps} from "@AppBuilderLib/shared/mantine-props/title";
import {AreaChart} from "@mantine/charts";
import {MantineThemeComponent, Paper, Title, useProps} from "@mantine/core";

/**
 * @docAttached
 * @category widget
 * @configPath themeOverrides.components.AppBuilderAreaChartWidgetComponent.defaultProps
 * @displayName AppBuilderAreaChartWidgetComponent
 */
export interface AppBuilderAreaChartWidgetComponentStyleProps {
	widgetProps?: MantinePaperProps;
	titleProps?: MantineTitleProps;
	areaChartProps?: MantineAreaChartProps;
}

const defaultStyleProps: Partial<AppBuilderAreaChartWidgetComponentStyleProps> =
	{
		widgetProps: {},
		titleProps: {
			style: {marginBottom: "20px"},
		},
		areaChartProps: {
			h: 250,
		},
	};

type AppBuilderAreaChartWidgetComponentThemePropsType =
	Partial<AppBuilderAreaChartWidgetComponentStyleProps>;

export function AppBuilderAreaChartWidgetComponentThemeProps(
	props: AppBuilderAreaChartWidgetComponentThemePropsType,
): MantineThemeComponent {
	return {
		defaultProps: props,
	};
}

export default function AppBuilderAreaChartWidgetComponent(
	props: IAppBuilderWidgetPropsAreaChart &
		AppBuilderAreaChartWidgetComponentThemePropsType,
) {
	const {name, style, type, plotSettings, data, ...rest} = props;

	const {widgetProps, titleProps, areaChartProps} = useProps(
		"AppBuilderAreaChartWidgetComponent",
		defaultStyleProps,
		rest,
	);

	return (
		<Paper {...widgetProps}>
			<Title {...titleProps}>{name}</Title>
			<AreaChart
				{...areaChartProps}
				withXAxis={plotSettings.xaxis}
				xAxisLabel={plotSettings.xlabel}
				withYAxis={plotSettings.yaxis}
				yAxisLabel={plotSettings.ylabel}
				gridAxis={plotSettings.grid}
				tickLine={plotSettings.grid}
				withDots={plotSettings.dots}
				withLegend={plotSettings.legend}
				data={convertChartData(data)}
				dataKey="key"
				series={data.series}
				curveType={style}
				type={type}
			/>
		</Paper>
	);
}
